import Reflux from 'reflux';
import CourseDetailActions from 'actions/CourseDetail';
import SteelCompass from 'services/SteelCompass';
// import { normalize, Schema, arrayOf } from 'normalizr';

import { normalize, Schema, arrayOf } from 'normalizr';
const student = new Schema('student');

const CourseDetailStore = Reflux.createStore({
  listenables: [CourseDetailActions],
  data: {
    courseId: null,
    students: {
      pageStart: 0,
      pageLength: 25,
      loading: true
    },
    token: null,
    isActive: null,
    list: {
      students: []
    },
    entities: {
      student: {}
    },
    totalStudents: 0,
  },

  getInitialState() {
    return this.data;
  },

  read(courseId) {
    this.data = {
      ...this.data,
      courseId,
      token: null,
      isActive: null,
    };
    this.getStudentsAtPage(0);
  },

  getStudentsAtPage(pageStart) {
    const { pageLength } = this.data.students;
    const options = {
      courseId: this.data.courseId,
      sortBy: 'name',
      sortMode: 'asc',
      isActive: this.data.isActive,
      token: this.data.token,
    };

    this.data.students.pageStart = pageStart;

    if (pageStart + pageLength < this.data.list.students.length) {
      this.trigger(this.data);
      return;
    }

    this.data.students.loading = true;
    this.trigger(this.data);

    return SteelCompass.request('user', 'findByCourseId', options, pageStart, pageLength)
      .then(response => {
        const newData = normalize(response, arrayOf(student));
        const { entities } = this.data;
        const students = pageStart === 0 ? newData.result : this.data.list.students.concat(newData.result);

        this.data = {
          ...this.data,
          students: {
            ...this.data.students,
            loading: false
          },
          entities: {
            ...entities,
            student: {
              ...this.data.entities.student,
              ...newData.entities.student
            }
          },
          list: {
            ...this.data.list,
            students
          }
        };
        this.trigger(this.data);
      });
  },
  nextStudents() {
    const newPageStart = this.data.students.pageStart + this.data.students.pageLength;
    this.getStudentsAtPage(newPageStart);
  },
  prevStudents() {
    if (this.data.students.pageStart >= this.data.students.pageLength) {
      const newPageStart = this.data.students.pageStart - this.data.students.pageLength;
      this.getStudentsAtPage(newPageStart);
    }
  },
  filterStudents(token) {
    if (this.data.token !== token) {
      this.data.token = token;
      this.getStudentsAtPage(0);
    }
  },
  filterStudentsByStatus(active) {
    if (this.data.isActive !== active) {
      this.data.isActive = active;
      this.getStudentsAtPage(0);
    }
  },
  countStudents(courseId) {
    return SteelCompass.call(
      'user',
      'countByCourseId',
      { courseId },
      response => {
        this.data.totalStudents = response.data;
        this.trigger(this.data);
      }
    );
  }
});

export default CourseDetailStore;



// WEBPACK FOOTER //
// ./src/js/stores/CourseDetail.js